import { type Language } from 'src/core/config/i18n';
import { getIsServiceConsentGiven } from 'src/onboarding/utils/userCentrics/getIsServiceConsentGiven';

type Props = {
  user?: {
    id: string;
    fullName: string;
    email: string;
    createdAt: string;
    isAccountOwner?: boolean;
    isAdmin?: boolean;
    isController?: boolean;
    isRequester?: boolean;
  };
  lang?: Language;
  companyId?: string;
};

export const initTandem = async ({ user, lang, companyId }: Props) => {
  if (appConfig.tandemAppId) {
    const consent = await getIsServiceConsentGiven('tandem');
    if (consent && appConfig.environmentName !== 'demo') {
      window.tandemSettings = {
        app_id: appConfig.tandemAppId,
        environment:
          appConfig.environmentName === 'production' ? 'production' : 'sandbox',
        language: lang,
        user: user
          ? {
              id: user.id,
              name: user.fullName,
              email: user.email,
              // eslint-disable-next-line camelcase
              custom_properties: {
                createdAt: user.createdAt,
                isAccountOwner: user.isAccountOwner,
                isAdmin: user.isAdmin,
                isController: user.isController,
                isRequester: user.isRequester,
                companyId,
              },
            }
          : undefined,
      };
    }
  }
};
